import React from "react";
import Container from "../../components/layout/Container";
import BaseLayout from "../../layouts/Base";
import Login from "../../components/layout/Auth/Login";

interface Props {}

const LoginPage = (props: Props) => {
  return (
    <BaseLayout hasHero={false}>
      <Container>
        <div className="my-20">
          <h1 className="text-4xl font-bold mb-10 text-center">Login</h1>
          <Login />
        </div>
      </Container>
    </BaseLayout>
  );
};

export default LoginPage;
